import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './empty.svg'


const _withScopeId = n => (_pushScopeId("data-v-66a37db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "widget-notice__body"
}
const _hoisted_2 = {
  key: 1,
  class: "widget-notice__empty"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "empty"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无新消息", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

interface Props {
  top: string
  left: string
  show: boolean
  data: any[]
  right: string
}


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'WidgetNotice' },
  __name: 'widget-notice',
  props: {
    top: {},
    left: {},
    show: { type: Boolean, default: false },
    data: { default: () => [] },
    right: {}
  },
  emits: ['update:show', 'view', 'read'],
  setup(__props: any, { emit: emits }) {



function onHidden(event: any) {
  if (!event.target.classList.contains('widget-notice')) return
  emits('update:show', false)
}




return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_Transition, { name: "fadeInUp" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: "widget-notice",
        onClick: onHidden
      }, [
        _createElementVNode("div", {
          class: "widget-notice__pane",
          style: _normalizeStyle({ top: _ctx.top, left: _ctx.left })
        }, [
          _createElementVNode("i", {
            class: "spot",
            style: _normalizeStyle({ right: _ctx.right })
          }, null, 4),
          (_ctx.data.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createElementVNode("h3", null, _toDisplayString(item.content), 1),
                      _createElementVNode("p", null, [
                        _createElementVNode("span", null, _toDisplayString(item.messageTypeName), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5)),
          _createElementVNode("div", {
            class: _normalizeClass(["widget-notice__foot", { end: _ctx.data.length === 0 }])
          }, [
            (_ctx.data.length > 0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  link: "",
                  class: "read",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('read')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("标记当前页已读")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "primary",
              link: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('view')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看全部")
              ]),
              _: 1
            })
          ], 2)
        ], 4)
      ], 512), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 1
  }))
}
}

})